import { render } from "./approve.vue?vue&type=template&id=174c2c4a&scoped=true&ts=true"
import script from "./approve.vue?vue&type=script&lang=ts"
export * from "./approve.vue?vue&type=script&lang=ts"

import "./approve.vue?vue&type=style&index=0&id=174c2c4a&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174c2c4a"]])

export default __exports__